import React from 'react';
import NumberFormat from 'react-number-format';
import { TextField, makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { clsx } from '@components/Provider';

interface CurrencyFormatTextFieldProps {
  className?: string;
  defaultValue?: string | number | null | undefined;
  onChange?: (e: any) => void;
  unit: '원' | '만원';
  fullWidth?: boolean;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  inputProps?: any;
  isPrimary?: boolean;
  align?: 'left' | 'right';
  onClick?: () => void;
}
export const CurrencyFormat = (props: CurrencyFormatTextFieldProps) => {
  const { currencyFormatStyle } = useStyles();

  return (
    <TextField
      onClick={props.onClick}
      required
      error={props.error}
      defaultValue={props.defaultValue ? props.defaultValue : ''}
      placeholder={props.placeholder}
      variant="outlined"
      className={clsx([currencyFormatStyle, props.className])}
      fullWidth={props.fullWidth ? props.fullWidth : true}
      helperText={props.helperText}
      InputProps={{
        inputComponent: NumberFormatCustom,
        endAdornment: (
          <CustomizedTypography
            variant="body2"
            color={props.isPrimary ? 'textPrimary' : 'textSecondary'}
            fontWeight="normal"
            className="unit"
          >
            {props.unit}
          </CustomizedTypography>
        )
      }}
      inputProps={{
        maxLength: 15,
        ...props.inputProps,
        style: {
          textAlign: props.align === 'right' ? 'right' : 'left'
        }
      }}
      onChange={(e) => {
        if (e.target.value.length > 16) {
          return null;
        }
        props.onChange && props.onChange(e.target.value);
      }}
    />
  );
};

export const NumberFormatCustom = (props: any) => {
  const { inputRef, onChange, ...rest } = props;
  return (
    <NumberFormat
      {...rest}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      isAllowed={({ value }) => value.length <= 12}
      thousandSeparator
      decimalScale={0}
      allowNegative={false}
    />
  );
};

export const NumberFormatCustomWithDecimalPoint = (props: any) => {
  const { inputRef, onChange, ...rest } = props;
  return (
    <NumberFormat
      {...rest}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      isAllowed={({ value }) => value.length <= 12}
      decimalSeparator="."
      thousandSeparator
      decimalScale={2}
      allowNegative={false}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  currencyFormatStyle: {
    marginBottom: '8px',
    '& .unit': {
      marginLeft: '8px'
    }
  }
}));
